/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const CANDIDATE_APPLICATION_PROMPT_RESPONSE_INPUT = gql`
  mutation UpdateCandidateApplicationPromptResponseNoId( $response: [CandidateApplicationPromptResponseInput!] ) {
    candidate {
      applications( response: $response ) {
        errors
        validations
      }
    }
  }
`;
